<div class="reports-dashboard">
  <h2>Reports Dashboard</h2>

  @if (loading) {
    <div class="loading-spinner">
      <mat-spinner diameter="40"></mat-spinner>
      <span>Loading reports...</span>
    </div>
  }

  @if (!loading) {
    <div>
      @for (category of categories; track category) {
        <div class="category-section">
          <h3 class="category-header">{{ category }}</h3>
          <table class="reports-table">
            <thead>
              <tr>
                <th class="col-name">Report Name</th>
                <th class="col-last-run">Last Run</th>
                <th class="col-actions">Actions</th>
              </tr>
            </thead>
            <tbody>
              @for (report of getReportsByCategory(category); track report) {
                <tr>
                  <td class="col-name">
                    <span class="report-name">{{ report.name }}</span>
                    @if (report.note) {
                      <span class="report-note">{{ report.note }}</span>
                    }
                  </td>
                  <td class="col-last-run">
                    @if (report.lastRun) {
                      <span class="last-run-time">{{ report.lastRun }}</span>
                    }
                    @if (!report.lastRun && !report.route) {
                      <span class="no-data">--</span>
                    }
                  </td>
                  <td class="col-actions">
                    @if (report.canView || report.canRun || report.canTest) {
                      @if (report.canView) {
                        <button mat-raised-button color="primary" class="action-btn view-btn"
                          [disabled]="isAnyActionLoading(report.key)"
                          (click)="viewReport(report)">
                          @if (isActionLoading(report.key, 'view')) {
                            <span>Generating...</span>
                          }
                          @if (!isActionLoading(report.key, 'view')) {
                            <span>View</span>
                          }
                        </button>
                      }
                      @if (report.canRun) {
                        <button mat-raised-button class="action-btn run-btn"
                          [disabled]="isAnyActionLoading(report.key)"
                          (click)="runReport(report)">
                          @if (isActionLoading(report.key, 'run')) {
                            <span>Sending...</span>
                          }
                          @if (!isActionLoading(report.key, 'run')) {
                            <span>Run Report</span>
                          }
                        </button>
                      }
                      @if (report.canTest) {
                        <button mat-raised-button class="action-btn test-btn"
                          [disabled]="isAnyActionLoading(report.key)"
                          (click)="testReport(report)">
                          @if (isActionLoading(report.key, 'test')) {
                            <span>Sending...</span>
                          }
                          @if (!isActionLoading(report.key, 'test')) {
                            <span>Run Test</span>
                          }
                        </button>
                      }
                    }
                    @if (report.route) {
                      <a [routerLink]="report.route" mat-raised-button color="accent" class="action-btn">
                        Open Dashboard
                      </a>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>
  }
</div>
